import config from "@/config"
import http from "@/utils/request"

export default {
	getPicChar: {
		url: `${config.API_URL}/lqa-game/game/report/getPieChart`,
		name: "获取版本信息",
		post: async function(data){
			return await http.post(this.url,data);
		}
	},
	getLineChar: {
		url: `${config.API_URL}/lqa-game/game/report/getLineChart`,
		name: "获取版本信息",
		post: async function(data){
			return await http.post(this.url,data);
		}
	},
	getLineLangChar: {
		url: `${config.API_URL}/lqa-game/game/report/getLineLangChar`,
		name: "获取版本信息",
		post: async function(data){
			return await http.post(this.url,data);
		}
	},
	getLineTypeChar: {
		url: `${config.API_URL}/lqa-game/game/report/getLineTypeChar`,
		name: "获取版本信息",
		post: async function(data){
			return await http.post(this.url,data);
		}
	},
	getLinePersonChar: {
		url: `${config.API_URL}/lqa-game/game/report/getLinePersonChar`,
		name: "获取版本信息",
		post: async function(data){
			return await http.post(this.url,data);
		}
	},
	
	
	


	getPillarChar: {
		url: `${config.API_URL}/lqa-game/game/report/getPillarChart`,
		name: "获取版本信息",
		post: async function(data){
			return await http.post(this.url,data);
		}
	},
	getBugTypeChar: {
		url: `${config.API_URL}/lqa-game/game/report/getBugTypeChart`,
		name: "BUG分类",
		post: async function(data){
			return await http.post(this.url,data);
		}
	},
	getBugPriorityChar: {
		url: `${config.API_URL}/lqa-game/game/report/getPriorityChar`,
		name: "BUG优先级",
		post: async function(data){
			return await http.post(this.url,data);
		}
	},
	getBugPersonChar: {
		url: `${config.API_URL}/lqa-game/game/report/getPersonChar`,
		name: "BUG创建人",
		post: async function(data){
			return await http.post(this.url,data);
		}
	},
	
	getLqaResult: {
		url: `${config.API_URL}/lqa-game/game/report/getLqaResult?versionNum=`,
		name: "获取版本信息",
		get: async function(param){
			return await http.get(this.url+param);
		}
	},
	getLqaReportData: {
		url: `${config.API_URL}/lqa-game/game/report/getExportData?versionNum=`,
		name: "获取版本信息",
		get: async function(param1,param2){
			return await http.get(this.url+param1+"&targetLanguage="+param2);
		}
	},
	
	exportReport: {
		url: `${config.API_URL}/lqa-game/game/report/stats_export`,
		name: "获取版本信息",
		post: async function(data){
			return await http.post(this.url,data);
		}
	},
	getTaskLogTime: {
		url: `${config.API_URL}/lqa-game/game/report/getTaskTime`,
		name: "获取版本信息",
		post: async function(data){
			return await http.post(this.url,data);
		}
	},
	
	getProNum: {
		url: `${config.API_URL}/lqa-game/game/report/getProjectNum?versionNum=`,
		name: "获取版本信息",
		get: async function(param){
			return await http.get(this.url+param);
		}
	},
	getDealPerson: {
		url: `${config.API_URL}/lqa-game/game/report/getDealPerson?projectNum=`,
		name: "获取版本信息",
		get: async function(param1,param2){
			return await http.get(this.url+param1+"&taskType="+param2);
		}
	},
	getTaskStatus: {
		url: `${config.API_URL}/lqa-game/game/report/getTaskStatus?projectNum=`,
		name: "获取版本信息",
		get: async function(param1,param2){
			return await http.get(this.url+param1+"&taskType="+param2);
		}
	},
	
	
	getLqaTaskTypeChar: {
		url: `${config.API_URL}/lqa-game/game/report/getTaskTypeChar?versionNum=`,
		name: "获取版本信息",
		get: async function(param1,param2,param3){
			return await http.get(this.url+param1+"&targetLanguage="+param2+"&lang="+param3);
		}
	},
	getLqaTaskTimeChar: {
		url: `${config.API_URL}/lqa-game/game/report/getTaskTimeChar?versionNum=`,
		name: "获取版本信息",
		get: async function(param1,param2,param3){
			return await http.get(this.url+param1+"&targetLanguage="+param2+"&lang="+param3);
		}
	},
	getLqaTaskDealTimeChar: {
		url: `${config.API_URL}/lqa-game/game/report/getTaskDealChar?versionNum=`,
		name: "获取版本信息",
		get: async function(param1,param2){
			return await http.get(this.url+param1+"&targetLanguage="+param2);
		}
	},
	getLqaItemDataTimeChar: {
		url: `${config.API_URL}/lqa-game/system/item/reportList`,
		name: "获取任务信息",
		get: async function (params) {
			return await http.get(this.url, params);
		}
	},
	getLqaTermDataTimeChar: {
		url: `${config.API_URL}/lqa-game/system/termdata/reportList`,
		name: "获取任务信息",
		get: async function (params) {
			return await http.get(this.url, params);
		}
	},
}
